var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-1 ml-1 mt-0 mr-0",attrs:{"color":"success","target":"_blank","href":_vm.viewLink}},[_vm._v(" "+_vm._s(_vm.$t('button_view'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }